<template>
  <section class="style-section">
    <div class="title-guide">安装软件升级过程出错</div>
    <div class="content-guide">
      软件升级时需要从远程服务器上下载需要的文件到本地电脑中，
      windows系统对于系统盘存在权限保护，容易出现这种因用户权限不足拒绝访问的情况。
      仅需将软件安装到其他盘符下即可。
      如电脑仅有1个盘符，那么采用管理员权限安装和运行程序可以解决这个问题。
    </div>
    <div class="img-guide">
      <el-image
        class="size-img"
        style="width: 500px; height: 180px"
        :src="url1"
        :fit="fit"
      />
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">双击图标打开程序登录界面不显示二维码</div>
    <div class="content-guide">
      本程序使用需要连接Internet网络，排出网络连接问题后，可以在系统搜索栏中输入“Internet选项”，
      在弹出的窗体中选择“高级”，查看安全选项下“TLS1.1”是否勾选，勾选后即可解决该问题。
    </div>
    <div class="img-guide">
      <el-image
        class="size-img"
        style="width: 400px; height: 360px"
        :src="url2"
        :fit="fit"
      />
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">程序界面字体显示偏大</div>
    <div class="content-guide">
      win10以上系统默认推荐字体大小会采用125%比例。
      如遇到打开程序后文字显示不全的问题，用户可以进入系统→屏幕→缩放与布局→更改文本、应用等项目的大小，
      将125%推荐值更改为100%。
    </div>
    <div class="img-guide">
      <el-image
        class="size-img"
        style="width: 200px; height: 120px"
        :src="url3"
        :fit="fit"
      />
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">标准库采用有误</div>
    <div class="content-guide">
      在装配式单梁模块和装配式梁格模块中，程序会提供多个标准库方便使用。
      但是部分标准库仅提供简支结构参数，未提供结构连续标准库。
      如果建立多跨模型，但是却采用了简支结构参数，就会导致在Midas
      Civil中显示钢束参数有误。
    </div>
    <div class="img-guide">
      <el-image
        class="size-img"
        style="height: 400px"
        :src="url4"
        :zoom-rate="1.2"
        :max-scale="1.5"
        :min-scale="0.2"
        :preview-src-list="srcList4"
        :initial-index="0"
        fit="cover"
      />
    </div>
    <div class="img-guide">
      <el-image
        class="size-img"
        style="width: 600px; height: 80px"
        :src="url5"
        :fit="fit"
      />
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">等高现浇箱梁模块生成梁格模型出错</div>
    <div class="content-guide">
      导出梁格模型前，需先进行梁格的横向划分工作，只有完成合理的横向划分后，方可正常导出梁格模型。
    </div>
    <div class="img-guide">
      <el-image class="size-img" style="height: 400px" 
        :src="url6"
        :zoom-rate="1.2"
        :max-scale="1.5"
        :min-scale="0.2"
        :preview-src-list="srcList6"
        :initial-index="0"
        fit="cover" />
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">mct文件导入提示版本错误</div>
    <div class="content-guide">
      本程序生成的mct文件支持Midas Civil v8.3.2版以后的所有版本，如果提示该错误一般都是mct文件导入方法有误引起的。
      在Midas Civil在导入本程序生成的mct文件时，不应使用“MCT命令窗口”功能，
      而是应采用“先新建项目，然后点击文件——导入——mct文件，最后选择本程序生成的mct文件”这样的方法。
    </div>
    <div class="img-guide">
      <el-image
        class="size-img"
        style="width: 455px; height: 456px"
        :src="url7"
        :fit="fit"
      />
    </div>
  </section>
  <el-divider></el-divider>
  <div style="height: 120px"></div>
</template>
<script>
export default {
  data() {
    return {
      url1: require("@/assets/png/error-1.png"),
      url2: require("@/assets/png/error-2.png"),
      url3: require("@/assets/png/error-3.png"),
      url4: require("@/assets/png/error-4.png"),
      url5: require("@/assets/png/error-5.png"),
      url6: require("@/assets/png/error-6.png"),
      url7: require("@/assets/png/error-7.png"),
      fit: "fill",
      srcList4: [require("@/assets/png/error-4.png")],
      srcList6: [require("@/assets/png/error-6.png")],
    };
  },
};
</script>
